(function (Drupal, once) {
  Drupal.behaviors.flexiGallery = {
    attach: function (context, settings) {
      once('gallery', '.layout-item--gallery').forEach((element) => {
        function handleResize() {
          const currentWidth = window.innerWidth;
          const containerElement = element.querySelector(".layout-item--gallery__container > .field");
          let numberOfColumns = element.querySelector(".layout-item--gallery__container").dataset.columns;

          if(currentWidth <= 768) {
            numberOfColumns = 1
          }
          
          containerElement.style.gridTemplateColumns = `repeat(${numberOfColumns}, 1fr)`;
        }

        // Calculate span
        function getSpanEstimateWidth(size) {
          let spanSize = 1
          return 1;

          switch (true) {
            case size > 500 && size < 1100:
              spanSize = 2;
              break;
            case size >= 1100 && size < 1500:
              spanSize = 3;
              break;
            case size >= 1500:
              spanSize = 4;
              break;
            default:
              break;
          }

          return spanSize
        }

        function getSpanEstimateHeight(size) {
          let spanSize = 1

          switch (true) {
            case size > 500 && size < 700:
              spanSize = 2;
              break;
            case size >= 700 && size < 1100:
              spanSize = 3;
              break;
            case size >= 1100:
              spanSize = 4;
              break;
            default:
              break;
          }

          return spanSize
        }

        // Gallery logic
        const getGalleryItems = element.querySelectorAll('.gallery-item');

        getGalleryItems.forEach(img => {
          // Set Grid
          const getImg = img.querySelector('.media__element');

          const imgWidth = getImg.getAttribute('width');
          const imgHeight = getImg.getAttribute('height');

          img.style.gridColumnEnd = `span ${getSpanEstimateWidth(imgWidth)}`;
          img.style.gridRowEnd = `span ${getSpanEstimateHeight(imgHeight)}`;
        });

        handleResize();

        window.addEventListener('resize', handleResize);
      });
    }
  };
})(Drupal, once);
